import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ParticleBackground from "@/components/ParticleBackground";
import AIGrid from "@/components/AIGrid";
import AnalyticsDashboardMockup from "@/components/AnalyticsDashboardMockup";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Analytics = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background relative overflow-hidden">
      <ParticleBackground />
      <AIGrid />
      <Navigation />
      
      <main className="flex-grow pt-32 pb-20 relative z-10">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 gradient-brand-text">
              Analytics & Insights
            </h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Real-time intelligence at your fingertips. Make data-driven decisions with comprehensive analytics.
            </p>
          </motion.div>

          <div className="mb-16">
            <AnalyticsDashboardMockup />
          </div>

          <div className="text-center">
            <Link to="/contact">
              <Button size="lg" className="bg-primary hover:bg-primary/90">
                Request Live Demo
              </Button>
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Analytics;
